import { inject, Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Image, ImageRepository } from '../core';
import { BaseService } from './base.service';
import { CaseService } from './case.service';
import { UserService } from './user.service';


/**
* This service handles the ray images data.
*/
@Injectable({ providedIn: 'root' })
export class ImageService extends BaseService {

	private readonly imgRepo = inject(ImageRepository);
	private readonly userSrv = inject(UserService);
	private readonly caseSrv = inject(CaseService);

	/**
	* Get image.
	* @param {string} image Image GUID.
	*/
	getImage(image: string): Observable<Image> {
		return combineLatest([
			this.userSrv.isCustomerCare(),
			this.caseSrv.getCurrentCase()
		]).pipe(
			map(([isCC, _case]) => isCC ? _case.userGuid : null),
			switchMap(user => this.imgRepo.getImageDetail(image, user)),
			map(res => this.handleApiResponse(res))
		);
	}

}
